import { Table } from '../../../Molecules/table';
import { GRAM_WISE_SINGLE_CARAT_COLUMN } from './GoldColumns';
import { GRAM_WISE_SINGLE_CARAT_DATA } from '../types';

export const CARAT_TABLE_CONFIG = [
  { carat: '24k', label: '24 Carat' },
  { carat: '22k', label: '22 Carat' },
  { carat: '18k', label: '18 Carat' },
  { carat: '14k', label: '14 Carat' },
  { carat: '12k', label: '12 Carat' },
  { carat: '9k', label: '9 Carat' },
];

export const CaratTableSection = ({
  label,
  carat,
  cityName,
  data,
}: {
  label: string;
  carat: string;
  cityName: string;
  data: GRAM_WISE_SINGLE_CARAT_DATA[];
}): JSX.Element => (
  <section className="mt-4 mb-8">
    <h2 className="text-s-28 font-bold text-font-500 sm:text-s-20">
      {label} Gold Price in {cityName} Today
    </h2>
    <div className="py-6">
      <Table
        columns={GRAM_WISE_SINGLE_CARAT_COLUMN}
        tableId={`gramwise${carat}CaratTable`}
        data={data}
        viewMoreToggle={false}
        smallWidth={true}
      />
    </div>
  </section>
);
